"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/ShoppingBag` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const ShoppingBag = createSVGIcon(
  <path
    d="M22.075 21.24a1.715 1.715 0 0 1-1.704 1.903H3.629a1.715 1.715 0 0 1-1.704-1.903L3.43 7.714h17.143zM7.714 7.714V5.143a4.286 4.286 0 1 1 8.572 0v2.571"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ShoppingBag",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "tMvsU7",
      defaultMessage: "Open shopping bag",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
    className: legacyIconCls(),
  })
);
